import { render, staticRenderFns } from "./checkTime.vue?vue&type=template&id=a473f866&scoped=true&"
import script from "./checkTime.vue?vue&type=script&lang=js&"
export * from "./checkTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a473f866",
  null
  
)

export default component.exports